import { AmbientImage } from '@digital-retail/shop-the-project';
import PropTypes from 'prop-types';
import { withApplicationContext } from '../../utils/ApplicationContext';
import { withCart } from '../../utils/CartContext';
import { withProduct } from '../../utils/ProductContext';
import { useShopTheProject } from './ShopTheProjectHook';

const AmbientImageWrapper = ({ activeImageIndex, mainProductImage, appCtx, product, cart, setIsCoachmarkVisible }) => {
  const {
    labels,
    mainProduct,
    handleAddToCart,
    getSecondaryProducts,
    analytics,
    useAmbientImage,
    getPrimaryProducts,
    ambientImageMediaUrl,
    mappedCoordinates,
    getPrimaryProduct,
    showCoachmark,
  } = useShopTheProject({
    activeImageIndex,
    mainProductImage,
    appCtx,
    product,
    cart,
    userInteraction: 'ambientImage',
    setIsCoachmarkVisible,
  });
  return (
    <div className="shop-the-project-ambient-image-container" data-testid="shop-the-project-ambient-image-container">
      <AmbientImage
        src={ambientImageMediaUrl}
        labels={labels}
        initialShowCoachmark={showCoachmark}
        mainProduct={mainProduct}
        addToCart={handleAddToCart}
        getSecondaryProducts={getSecondaryProducts}
        deviceType={appCtx.deviceType}
        analytics={analytics}
        useLazyLoading={useAmbientImage}
        getPrimaryProducts={getPrimaryProducts}
        dots={mappedCoordinates}
        getPrimaryProduct={getPrimaryProduct}
      />
    </div>
  );
};

AmbientImageWrapper.defaultProps = {
  setIsCoachmarkVisible: () => {},
};

AmbientImageWrapper.propTypes = {
  activeImageIndex: PropTypes.number.isRequired,
  mainProductImage: PropTypes.string.isRequired,
  appCtx: PropTypes.object.isRequired,
  product: PropTypes.object.isRequired,
  cart: PropTypes.object.isRequired,
  setIsCoachmarkVisible: PropTypes.func,
};

export { AmbientImageWrapper };
export default withProduct(withApplicationContext(withCart(AmbientImageWrapper)));
